import React from 'react';
import { listHelp } from '../../services/helpApi';

const AdminHelp = () => {
  const [rows, setRows] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState('');

  const load = async () => {
    try {
      setLoading(true);
      const { data } = await listHelp(
        new URLSearchParams({ page: '1', limit: '50' })
      );
      setRows(data || []);
    } catch (e) {
      setError(e.message || 'Failed to load');
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    load();
  }, []);

  // read-only

  return (
    <div className="max-w-[1140px] w-full mx-auto px-4 sm:px-6 lg:px-0">
      <div
        className="bg-white rounded-[12px] p-4 sm:p-6"
        style={{ boxShadow: '0px 4px 16px 0px #0000001A' }}
      >
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-[#000] text-[20px] font-semibold">
            Help Requests
          </h2>
          <button onClick={load} className="text-sm text-[#111]">
            Refresh
          </button>
        </div>
        {loading ? (
          <p>Loading...</p>
        ) : error ? (
          <p className="text-red-600">{error}</p>
        ) : rows.length === 0 ? (
          <p>No help requests yet.</p>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full min-w-[700px]">
              <thead>
                <tr className="bg-[#F3F4F6]">
                  <th className="px-4 py-3 text-left text-xs uppercase">
                    Name
                  </th>
                  <th className="px-4 py-3 text-left text-xs uppercase">
                    Email
                  </th>
                  <th className="px-4 py-3 text-left text-xs uppercase">
                    Phone
                  </th>
                  <th className="px-4 py-3 text-left text-xs uppercase">
                    Message
                  </th>
                  <th className="px-4 py-3 text-left text-xs uppercase">
                    Status
                  </th>
                  <th className="px-4 py-3 text-left text-xs uppercase">
                    Date
                  </th>
                </tr>
              </thead>
              <tbody>
                {rows.map((r) => (
                  <tr key={r._id} className="border-b">
                    <td className="px-4 py-3">{r.name}</td>
                    <td className="px-4 py-3">{r.email}</td>
                    <td className="px-4 py-3">{r.phone || '-'}</td>
                    <td
                      className="px-4 py-3 max-w-[280px] truncate"
                      title={r.message}
                    >
                      {r.message}
                    </td>
                    <td className="px-4 py-3">{r.status}</td>
                    <td className="px-4 py-3">
                      {new Date(r.createdAt).toLocaleString()}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminHelp;
